import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import moment from 'moment';
import { formatDatetime } from 'Modules/reports/views/main/components/reportsTab/helper';
import { getDateFromReactCalendarToUtc } from '../../../../../../components/Map/utils';
import {
    Grid
} from '@mui/material';

import './style.scss'

import { Button, DatePicker,  Switch, Form, Select } from '@gpstrackit/gtc-react-controls';
import { GetFormatForMoment } from 'Core/data/Helpers';
import { useIntl } from 'react-intl';

import { reset as resetEditPanelRoute } from '../../../templates/components/editPanelRoute/redux/slice'

import {
    openModalRoutesTrackerAddRoutesTracker,
    routesTrackerAddSearchRoutes,
    openModalCreateEditRouteModalMain,
    catalogLoad,
    onUpdateRoute
  } from 'Redux/actions';

import { reset as resetModalAddRoutesTracker } from './redux/slice'

const ModalAddRoutesTracker = (props) => {


    const { messages, locale } = useIntl();

    const [formData, setFormData] = useState({useTemplate : true, routeTemplate: 0, scheduledAt: new Date()});

    const dispatch = useDispatch();
    const designForm = Form.useForm();
    const defaultFrame = "today"



    const loadingRoutes = useSelector(state => state.routesTrackerModalAddRoutesTrackerRedux.loadingRoutes);
    const routes = useSelector(state => state.routesTrackerModalAddRoutesTrackerRedux.routes);

    const dateformat = useSelector(state => state.securityRedux.user.dateformat);
    const open = useSelector(state => state.routesTrackerModalAddRoutesTrackerRedux?.open);
    const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
    const loadingDrivers = useSelector(state => state.catalogsRedux.loadingDrivers);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
    

    useEffect(() => {
        dispatch(routesTrackerAddSearchRoutes({})) //search templates routes to create a routes trackers
        dispatch(resetEditPanelRoute())
        dispatch(catalogLoad(["drivers"], true))
    },[])

    useEffect(()=> {
        setFormData({...formData, scheduledAt: formatDatetime(new Date(), `YYYY/MM/DD h:mm A` , timeZoneUser) }) 
    }, [timeZoneUser])
    
    const handleToggle = () => {
        dispatch(openModalRoutesTrackerAddRoutesTracker({open: false}));
    }

    const onLoadRouteTrackerToCreate = () => {

        const formattedDateInUTC = getDateFromReactCalendarToUtc(formData?.scheduledAt, timeZoneUser);

        dispatch(onUpdateRoute({ changesToSave: true }))
        dispatch(openModalCreateEditRouteModalMain({
            open: true, 
            isCloneRoute: formData.useTemplate ? true : false,
            isRoutesTracker: true,
            isNewRoutesTracker: true,
            isTemplate: false,
            templateRouteId: formData.useTemplate ? formData?.routeTemplate?.id || 0 : 0,
            id: formData.useTemplate ? formData?.routeTemplate?.id || 0 : 0,
            driverId : formData.driverId,
            scheduledAt: formattedDateInUTC
        })); 
        //clear redux
        dispatch(resetModalAddRoutesTracker())
    }

    const validateAddRouteTracker = () => {
        let validation = true;

        if(!formData?.scheduledAt){
            validation = false
        }

        if(formData?.useTemplate && (formData?.routeTemplate?.id <= 0 || !formData?.routeTemplate)){
            validation = false
        }

        return validation;
    }

    return (
        <div id='idPanelRouteModal'>
        <SidePanel 
            isOpen={open} 
            onToggle={handleToggle} 
            hiddenButton={false} 
            style={{ width: '350px', transform: 'translateX(350px)' }} 
            //position={"right"}
            //classSidePanel={args.classSidePanel}
            //classPanelContent={args.classPanelContent}
            //contentStyle={args.contentStyle}
        >
            <SidePanelHeader>
                <h2 style={{ margin: 0, fontFamily: '"Outfit",sans-serif' }}>{messages['fsmRoute_routesTracker_modalAdd_title']}</h2> 
            </SidePanelHeader>
            <SidePanelBody style={{ height: '90%' }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    }}
                >
                    <div style={{ width: '100%' }}>

                        <Form
                            ref={designForm.ref}
                            loading={loadingRoutes || loadingDrivers}
                            onValidSubmit={() => {}}
                            onChangeValues={(values) => {
                            }}
                        >

                        <div className='routes-tracker-div'>
                            <label className='label-gtc-rc'>
                                {messages['fsmRoute_routesTracker_modalAdd_useTemplate']}
                            </label>
                            <Switch 
                                backgroundColorClass='gtc-rc-blue-switch' 
                                id="useTemplate"
                                checked={formData?.useTemplate || false} 
                                optionLabels={[messages['yes'], messages['no']]}
                                size="large"
                                labelPosition="right"
                                onChange={(value) => {
                                    setFormData({ ...formData, useTemplate: value });
                            }}/>
                        </div>
                        {
                            formData?.useTemplate
                            &&
                            
                            <div className='routes-tracker-div'>
                                <Select 
                                    name="StorySelect"
                                    textField="title"
                                    label={messages['fsmRoute_routesTracker_modalAdd_template']}
                                    valueField="id"
                                    placeholder={messages['fsmRoute_routesTracker_modalAdd_select_template']}
                                    isMulti={false}
                                    options={routes || []}
                                    isDisabled={false}
                                    isLoading={loadingRoutes}
                                    showPillsOutside={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    value={formData?.routeTemplate}
                                    onChange={(value) => {
                                        setFormData({ ...formData, routeTemplate: value });
                                }}/>
                            </div>
                            
                        }
                        <div className='routes-tracker-div'>
                            <Select 
                                style={{
                                    width: '100%'
                                }}
                                name="driverSelect"
                                textField="name"
                                label={messages['fsmRoute_routesTracker_modalAdd_select_driver']}
                                valueField="driverId"
                                placeholder={messages['fsmRoute_routesTracker_modalAdd_select_driver_select']}
                                isMulti={false}
                                options={drivers || []}
                                isDisabled={false}
                                isLoading={loadingDrivers}
                                showPillsOutside={true}
                                isClearable={true}
                                isSearchable={true}
                                value={
                                drivers
                                    ? drivers.find(
                                    (driver) =>
                                        driver?.driverId.toString() ===
                                        formData?.driverId?.toString()
                                    )
                                    : {}
                                }
                                onChange={(value) => {
                                setFormData({ ...formData, driverId: value?.driverId || 0 });
                            }}/>
                        </div>
                        <div className='routes-tracker-div'>
                            <div>
                                <label className='label-gtc-rc'>{messages['fsmRoute_edit_panel_route_schedule_at']}</label>
                            </div>
                            <div style={{ marginTop: 5}}>
                                <DatePicker 
                                    showButtons={true}
                                    showTimePicker={true}
                                    calendarPosition={"left"}
                                    placeholder={messages['fsmRoute_routesTracker_modalAdd_select_date']}
                                    format={`${GetFormatForMoment(dateformat)}`}
                                    value={formData?.scheduledAt || new Date()} 
                                    minDate={new Date()}
                                    onChange={(newDate) => setFormData({ ...formData, scheduledAt : newDate})}/>
                            </div>
                        </div>
                        </Form>
                    </div>
                </div> 
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    }}
                >
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={handleToggle}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        variant="primary"
                        isDisabled={loadingRoutes || !validateAddRouteTracker()}
                        onClick={(e) => {
                            e.preventDefault();
                            onLoadRouteTrackerToCreate();
                        }}
                    >
                        {messages['fsmRoute_routesTracker_modalAdd_next']}
                    </Button>
                </div>      
            </SidePanelFooter>
        </SidePanel>
        </div>
    )
}




export default ModalAddRoutesTracker;